// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import require from './network/index'
import remind from './network/remind'
import cookie from './network/cookie'
import 'babel-polyfill'
// import Header from './components/header/header.vue'

// import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import "katex/dist/katex.min.css";

Vue.use(VueCodeMirror)
// Vue.use(Element);
// Vue.use(Header)
Vue.config.productionTip = false;
Vue.prototype.$http = require;
Vue.prototype.$remind = remind;
Vue.prototype.$cookie = cookie;

import { Encrypt,Decrypt } from "./network/encryp";
Vue.prototype.$Encrypt = Encrypt;
Vue.prototype.$Decrypt = Decrypt;

import Router from 'vue-router'

// import 'github-markdown-css/github-markdown.css'
import hljs from "highlight.js";
// 代码块配色由 components/markdown/codeBlockPalette.js 统一提供（浅色一套），
// 不再引入 highlight.js 的深色主题，避免两套背景色互相覆盖。

// 自定义命令v-highlight
Vue.directive("highlight", function(el) {
  let blocks = el.querySelectorAll("pre code");
  blocks.forEach(block => {
    hljs.highlightBlock(block);
  });
});

Vue.prototype.$hljs = hljs;

router.beforeEach((to, from, next) => {
  //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  let version = localStorage.getItem('version');
  if (version !== "" && version !== "null" && version !== null && version !== config.version) {
    remind.messageBox(`系统检测到有新版本，是否更新？`).then(_ => {
      localStorage.setItem('version', config.version);
      window.location.reload();
    }).catch(_ => {
      // localStorage.setItem('version', config.version);
    })
  }else{
    localStorage.setItem('version', config.version);
  }
  next();
})
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
  // components: { App },
  // template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js